import React from "react"
import {Link} from "gatsby"
import { ArrowLeft } from "../icons/arrow-left-icon"

const SuccessMessage = ({name, type}) => {
  const messageTitle = type ? `Hi ${name}! Thank you for submitting :)` : `Sorry ${name}, your email is invalid :(`
  const messageDescription = type ? `I will get back to you as soon as I can! Have a good one!` : `Please try again.`
  return (
    <>
      <section
        id="successForm"
        className="flex z-20 flex-col overflow-hidden items-center justify-center w-full mx-auto min-h-screen bg-gradient-to-br from-green-400 via-blue-500 to-purple-500 shadow-inner"
      >
        <div className="slide-fwd-center w-auto bg-primary shadow-2xl rounded-lg p-12">
          <p className={`font-body2 text-3xl lg:text-4xl md:text-3xl sm:text-3xl font-bold my-6 text-center ${type ? "text-success" : "text-danger"}`}>
            {messageTitle}
          </p>
          <p className="mt-6 text-center text-quarternary px-6 font medium md:font-semibold text-lg sm:text-xl md:text-2xl">
            {messageDescription}
          </p>
          {type && (
            <Link to="/" className="flex justify-center items-center select-none">
            <button className="mt-16 mb-16 inline-block w-auto font-bold text-sm sm:text-md md:text-lg lg:text-2xl cursor-pointer transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100 border-2 border-blue-200 dark:border-gray-600  hover:border-blue-500 dark:hover:border-white rounded-full">
              <div class="flex flex-cols-2 px-6 py-4 space-x-3 md:px-11 md:py-6 md:space-x-5 hover:text-quarternary">
                <ArrowLeft className="w-4 h-4 lg:w-8 lg:h-8 " />
                <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-secondary-text hover:text-current ">Go back home</span>
              </div> 
            </button>
          </Link>
          )}
        </div>
      </section>
    </>
  )
}

export default SuccessMessage
